import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path stroke={color} strokeWidth="2" d="m2 7 9.5-4L21 7v3H2zm2 3v8h5v-8zm-2 8v3h19v-3zm7-8v8h5v-8zm5 0v8h5v-8z" />
  </svg>
);
